/*
  Ivy Pillow — FAQ-filtertabs: filtert de accordeon op groep. 'Alle' toont
  alles inclusief de groepskoppen; een specifieke tab verbergt de koppen en
  de vragen van andere groepen. Toggle-knoppen met aria-pressed.
*/
(() => {
  function initIvyFaq(scope) {
    const bereik = scope && scope.querySelectorAll ? scope : document;
    bereik.querySelectorAll('.ivy-faq').forEach((sectie) => {
      if (sectie.dataset.ivyInit === 'true') return;
      sectie.dataset.ivyInit = 'true';

      // Open/dicht klappen van de vragen
      sectie.querySelectorAll('[data-faq-item] .ivy-faq__vraag').forEach((knop) => {
        knop.addEventListener('click', () => {
          const item = knop.closest('[data-faq-item]');
          const open = item.classList.toggle('ivy-faq__item--open');
          knop.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      const tabs = Array.from(sectie.querySelectorAll('[data-faq-tab]'));
      if (!tabs.length) return;
      const items = Array.from(sectie.querySelectorAll('[data-faq-groep]'));

      const filter = (groep) => {
        tabs.forEach((tab) => {
          const actief = tab.dataset.faqTab === groep;
          tab.classList.toggle('ivy-faq__tab--actief', actief);
          tab.setAttribute('aria-pressed', String(actief));
        });
        items.forEach((item) => {
          const isKop = item.classList.contains('ivy-faq__groepskop');
          let verberg;
          if (groep === 'alle') {
            verberg = false;
          } else if (isKop) {
            verberg = true;
          } else {
            verberg = item.dataset.faqGroep !== groep;
          }
          item.toggleAttribute('data-faq-verborgen', verberg);
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => filter(tab.dataset.faqTab));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initIvyFaq(document));
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initIvyFaq(e.target));
  }
})();
